import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ecl_admin_token";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=loading, false=not auth, object=admin
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));

  const verify = useCallback(async (t) => {
    if (!t) { setAdmin(false); return; }
    try {
      const { data } = await axios.get(`${API}/admin/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setAdmin(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setAdmin(false);
    }
  }, []);

  useEffect(() => { verify(token); }, [token, verify]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setToken(data.access_token);
    setAdmin(data.admin);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setAdmin(false);
  };

  const authHeader = () => (token ? { Authorization: `Bearer ${token}` } : {});

  return (
    <AuthContext.Provider value={{ admin, token, login, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
